/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext, useCallback } from 'react';
import { FluidContainer, SimpleTabs, TableTraining, TableAccExams, Loader } from '../../../components';
import { ARMcontext } from '../../../utils/context/context';
import { Teams } from '../../../utils/api';
import { RadiosContainer, TableWrapper, RadiosWrapper } from '../styles';
import PaginationControls from '../../../components/PaginationControls/PaginationControls';
import { URL_ACCOUNTABILITY } from '../../../utils/constants/routes';
import { useLocation, useNavigate } from 'react-router-dom';
import { CacheKeysTables, KeyAccountabilityCache } from '../../../utils/constants/keyCache';
import { getQueryCacheForTable } from '../../../utils/helpers/queryCacheKey';

const TableDefaultTabs = [
  {
    title: 'TRAINING',
    url: 'training',
    icon: '',
    action: () => { },
  },
  {
    title: 'EXAMS',
    url: 'exams',
    icon: '',
    action: () => { },
  },
];

export default ({
  isFirstLoad,
  playersGroup,
  playerNameSearch
}: {
  isFirstLoad: boolean;
  playersGroup: string;
  playerNameSearch: string
}) => {
  const [exams, useExams] = useState<Array<object | any>>([]);
  const [teamAverage, useTeamAverage] = useState({});
  const { selectedTeam, triggerRefresh, setTriggerRefresh } = useContext(ARMcontext);
  const { HandleToastMessage } = useContext(ARMcontext);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [loadingTable, setLoadingTable] = useState(true);
  const [isFirstLoadAccountability, setFirstLoadAccountability] = useState(true);
  const [currentPlayerSearch, setCurrentPlayerSearch] = useState(playerNameSearch);
  const TEAMS = new Teams();
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    recordsPerPage: 20
  });

  const [sortConfig, setSortConfig] = useState({ key: 'firstName', direction: 'desc' });

  const handleSort = useCallback((key) => {
    setSortConfig(prevSort => ({
      key,
      direction: prevSort.key === key && prevSort.direction === 'asc' ? 'desc' : 'asc',
    }));
  }, []);

  useEffect(() => {
    if(playersGroup === undefined) return;
    if (!isFirstLoad || isFirstLoadAccountability) getAccountabilityExams();
  }, [playersGroup, selectedTeam?._id, pagination.currentPage, pagination.recordsPerPage, sortConfig.key, sortConfig.direction, playerNameSearch]);

  useEffect(() => {
    if(pathname !== URL_ACCOUNTABILITY.EXAMS && pathname !== URL_ACCOUNTABILITY.TRAINING){
      navigate('/players/accountability/training');
    } else {
      setFirstLoadAccountability(false)
    }
  }, [history]);

  const triggerRefreshAccountability = async () => {
    await getAccountabilityExams();
    setTriggerRefresh({
      ...triggerRefresh,
      accountability: false,
    })
  }
  useEffect(()=>{
    if(triggerRefresh.accountability)
      triggerRefreshAccountability();
  }, [triggerRefresh.accountability])

  async function getAccountabilityExams() {
    setLoadingTable(true);
    const isSamePlayerSearch = currentPlayerSearch === playerNameSearch;
    const accountabilityData = getQueryCacheForTable({
      selectedTeam,
      playersGroup,
      page: pagination.currentPage,
      recordsPerPage: pagination.recordsPerPage,
      sortBy: sortConfig.key,
      sortOrder: sortConfig.direction,
      mainCacheKey: KeyAccountabilityCache.table,
      playerNameSearch,
    })
    const examsResponse = await TEAMS.ExecuteCacheRequest({
      isForceDelete: !isSamePlayerSearch,
      cacheKey: accountabilityData.cacheKey,
      queryFn: () => TEAMS.GetAccountabilityExams(
        selectedTeam._id,
        playersGroup,
        playerNameSearch,
        pagination.currentPage,
        pagination.recordsPerPage,
        sortConfig.key,
        sortConfig.direction
      )
    });

    if (examsResponse.status) {
      useExams(examsResponse.data.records);
      setPagination(prev => ({
        ...prev,
        currentPage: examsResponse.data.pagination.currentPage,
        totalPages: examsResponse.data.pagination.totalPages,
        totalItems: examsResponse.data.pagination.totalItems,
      }));
      setCurrentPlayerSearch(playerNameSearch);

      const avgKey = CacheKeysTables(KeyAccountabilityCache.avg, accountabilityData.secondaryCacheOpts);
      TEAMS.ExecuteCacheRequest({
        isForceDelete: !isSamePlayerSearch,
        cacheKey: avgKey,
        queryFn: () => TEAMS.GetAccountabilityTeamAverage(selectedTeam._id, playersGroup)
      }).then(averageResult => {
        if (averageResult.status && averageResult.data) {
          useTeamAverage(averageResult.data.teamAverage);
        }
      })


    } else {
      HandleToastMessage(examsResponse?.data?.message || 'Server error', true, 2000, 'error');
    }
    setLoadingTable(false);
  }
  return (
    <FluidContainer overflow={true}>
      <RadiosWrapper alignItems="center">
        <RadiosContainer data-cy="accountability-navigation">
          <SimpleTabs dataArray={TableDefaultTabs} url={'/players/accountability'} />
        </RadiosContainer>
      </RadiosWrapper>

      <TableWrapper>
        {loadingTable ?
          (<div style={{ width: "100%", display: 'block', alignItems: 'center' }}><Loader height="90px" /></div>)
          : (
            <>
              {window.location.href.includes('/accountability/exams') && (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <TableAccExams filter={playerNameSearch}
                  dataTableContent={exams}
                  teamAverage={teamAverage}
                  minWidth="1200px"
                  handleSort={handleSort}
                  sortBy={sortConfig.key}
                  sortOrder={sortConfig.direction}
                  />
                  <PaginationControls
                  currentPage={pagination.currentPage}
                  totalPages={pagination.totalPages}
                  totalItems={pagination.totalItems}
                  recordsPerPage={pagination.recordsPerPage}
                  onPageChange={(page) => setPagination(prev => ({ ...prev, currentPage: page }))}
                  onLimitChange={(limit) => setPagination(prev => ({ ...prev, recordsPerPage: limit, currentPage: 1 }))}
                  />
                </div>
              )}

              {window.location.href.includes('/accountability/training') && (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <TableTraining filter={playerNameSearch}
                   dataTableContent={exams}
                    teamAverage={teamAverage}
                    minWidth="1200px"
                    handleSort={handleSort}
                    sortBy={sortConfig.key}
                  sortOrder={sortConfig.direction} />
                  <PaginationControls
                  currentPage={pagination.currentPage}
                  totalPages={pagination.totalPages}
                  totalItems={pagination.totalItems}
                  recordsPerPage={pagination.recordsPerPage}
                  onPageChange={(page) => setPagination(prev => ({ ...prev, currentPage: page }))}
                  onLimitChange={(limit) => setPagination(prev => ({ ...prev, recordsPerPage: limit, currentPage: 1 }))}
                  />
                </div>
              )}
            </>
          )
        }
      </TableWrapper>
    </FluidContainer>
  );
};
